module.exports = __webpack_public_path__ + "static/media/IMG_1275.c15da58b.jpg";